import request from '../utils/request'
//调解案件列表
export function mediateList(obj) {
    return request.post('/api/tiaojie_case_list',obj)
}
//调解立案
export function putOnRecord(need_tjshu,doc_title,contract_sn,sign_time,signers) {
    let obj={
        "need_tjshu":need_tjshu,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "signers":signers
    }
    return request.post('/api/add_tiaojie_case',obj)
}
//获取调解案件模板
export function mediationTemplate() {
    return request.post('/api/tiaojie_case_tem_url')
}
//批量绑定证据清单
export function batchBindingProof(case_ids,product_id) {
    return request.post('/api/batch_bind_tiaojie_evi',{"case_ids":case_ids,"product_id":product_id})
}
//批量绑定补充证据清单
export function supplementaryEvidence(case_ids,extra_id) {
    return request.post('/api/batch_bind_extra_tiaojie_evi',{"case_ids":case_ids,"extra_id":extra_id})
}
//调解清单详情
export function settlementList(case_id) {
    return request.post('/api/tiaojie_case_evidence_detail',{"case_id":case_id})
}
//调解清单 保存
export function mediateListSave(case_id,evidence_data) {
    return request.post('/api/tiaojie_case_save_evidence',{"case_id":case_id,"evidence_data":evidence_data})
}
//调解补充证据
export function mediateSupplementList(case_id) {
    return request.post('/api/tiaojie_case_extra_evidetail',{"case_id":case_id})
}
//调解补充证据 保存
export function mediateSupplementSave(case_id,evidence_data) {
    return request.post('/api/tiaojie_case_save_extra_evi',{"case_id":case_id,"evidence_data":evidence_data})
}
//调解案件进度
export function mediationProgress(case_id) {
    return request.post('/api/tiaojie_case_scan_progress',{"case_id":case_id})
}
//调解案件详情
export function mediateCaseDetails(case_id) {
    return request.post('/api/tiaojie_case_detail',{"case_id":case_id})
}
//调解案件企业申请人身份证明
export function identityCertificate(case_id) {
    return request.post('/api/com_id_tiaojie_ddall',{"case_id":case_id})
}
//调解案件证据清单
export function mediateAllEvidence(case_id) {
    return request.post('/api/tiaojie_case_dd_zju',{"case_id":case_id})
}
//调解案件申请人其他证据
export function mediateOtherEvidence(case_id) {
    return request.post('/api/qita_tiaojie_evi_download_all',{"case_id":case_id})
}
//调解案件补充证据
export function  mediateReplenishment(case_id) {
    return request.post('/api/tiaojie_case_dd_extrazju',{"case_id":case_id})
}
//调解案件仲裁文书
export function mediateWrit(case_id) {
    return request.post('/api/tiaojie_case_dd_wenshu',{"case_id":case_id})
}
// 批量提交调解案件到代理人
export function submitMediateCase(case_ids) {
    return request.post('/api/tiaojie_case_batch_submit',{"case_ids":case_ids})
}
//合同转为调解案件详情
export function transferConciliation(signer_list_id) {
    return request.post('/api/contract_to_tiaojie_detail',{"signer_list_id":signer_list_id})
}
//调解合同转调解案件
export function conversionMediation(signer_list_id,need_tjshu,doc_title,contract_sn,sign_time,signers) {
    let obj={
        "signer_list_id":signer_list_id,
        "need_tjshu":need_tjshu,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "signers":signers
    }
    return request.post('/api/contract_to_tiaojie_save',obj)
}
//管理员 合同转为调解案件详情
export function ConvertAllMediate(contract_id) {
    return request.post('/api/contadmin_to_tiaojie_detail',{"contract_id":contract_id})
}
//管理员全部合同 转为调解案件
export function confirmedConversion(contract_id,need_tjshu,doc_title,contract_sn,sign_time,signers) {
    let obj={
        "contract_id":contract_id,
        "need_tjshu":need_tjshu,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "signers":signers
    }
    return request.post('/api/contadmin_to_tiaojie_save',obj)
}
//删除调解案件
export function cancelMediateCase(case_id) {
    return request.post('/api/tiaojie_case_delete',{"case_id":case_id})
}
//修改调解案件
export function echoInformation(case_id) {
    return request.post('/api/tiaojie_case_edit_detail',{"case_id":case_id})
}
//保存修改调解案件信息
export function definiteModification(case_id,need_tjshu,doc_title,contract_sn,sign_time,signers) {
    let obj={
        "case_id":case_id,
        "need_tjshu":need_tjshu,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "signers":signers
    }
    return request.post('/api/edit_tiaojie_case',obj)
}
